module.exports = __webpack_public_path__ + "img/password-manager.ad3bbc25.svg";